import { gql, useMutation } from "@apollo/client";
import { MutationUpdateProjectFileArgs } from "../../__generated__/types";

const CREATE_PROJECT_FILE_MUTATION = gql`
  mutation UpdateProjectFile(
    $_id: ID!
    $designerId: ID
    $name: String
    $description: String
    $style: ProjectStyles
    $projectCategory: ProjectCategory
    $specialRequirements: [SpecialRequirements]
    $budgetRange: BudgetRange
    $squareFootage: SquareFootage
    $projectDuration: ProjectDuration
    $images: [ID]
    $displayOrder: Int
    $featuredOnBio: Boolean
    $published: Boolean
  ) {
    updateProjectFile(
      _id: $_id
      designerId: $designerId
      name: $name
      description: $description
      style: $style
      projectCategory: $projectCategory
      specialRequirements: $specialRequirements
      budgetRange: $budgetRange
      squareFootage: $squareFootage
      projectDuration: $projectDuration
      images: $images
      displayOrder: $displayOrder
      featuredOnBio: $featuredOnBio
      published: $published
    ) {
      _id
      name
      description
      style
      projectCategory
      specialRequirements
      budgetRange
      squareFootage
      projectDuration
      images
      displayOrder
      featuredOnBio
      published
    }
  }
`;

export const useUpdateProjectFileMutation = () => {
  const [createProjectFileMutation, { loading, error, data }] = useMutation(
    CREATE_PROJECT_FILE_MUTATION
  );

  const updateProjectFile = async (
    args: MutationUpdateProjectFileArgs & { displayOrder?: number | null }
  ) => {
    try {
      const { data } = await createProjectFileMutation({
        variables: args,
      });
      return data?.updateProjectFile;
    } catch (error) {
      console.error("Error updating project file:", error);
      throw error;
    }
  };

  return { updateProjectFile, loading, error, data };
};
